const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const message = typeof payload === 'string'
      ? payload
      : payload?.message || 'Bir hata oluştu';
    throw new Error(message);
  }

  return payload;
}

export async function getCurrentUser() {
  return request('/auth/me');
}

export async function login(credentials) {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
}

export async function logout() {
  return request('/auth/logout', {
    method: 'POST',
  });
}

export async function getDashboardStats() {
  return request('/dashboard/stats');
}

export async function getColors(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/colors${query ? `?${query}` : ''}`);
}

export async function getProducts(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/products${query ? `?${query}` : ''}`);
}

export async function getAdminProduct(id) {
  return request(`/products/admin/${id}`);
}

export async function createProduct(payload) {
  return request('/products', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateProduct(id, payload) {
  return request(`/products/admin/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteProduct(id) {
  return request(`/products/admin/${id}`, {
    method: 'DELETE',
  });
}

export async function cloneProduct(id) {
  return request(`/products/admin/${id}/clone`, {
    method: 'POST',
  });
}

export async function reorderProducts(items) {
  return request('/products/admin/reorder', {
    method: 'POST',
    body: JSON.stringify({ items }),
  });
}

export async function getProduct(slug) {
  return request(`/products/${slug}`);
}

export async function getProjects(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/projects${query ? `?${query}` : ''}`);
}

export async function getProject(slug) {
  return request(`/projects/${slug}`);
}

export async function getProjectById(id) {
  return request(`/projects/admin/${id}`);
}

export async function createProject(payload) {
  return request('/projects', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateProject(id, payload) {
  return request(`/projects/admin/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteProject(id) {
  return request(`/projects/admin/${id}`, {
    method: 'DELETE',
  });
}

export async function cloneProject(id) {
  return request(`/projects/admin/${id}/clone`, {
    method: 'POST',
  });
}

export async function getBlogPosts(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/blog-posts${query ? `?${query}` : ''}`);
}

export async function getBlogPost(slug) {
  return request(`/blog-posts/${slug}`);
}

export async function getAdminBlogPosts() {
  return request('/blog-posts/admin');
}

export async function getAdminBlogPost(id) {
  return request(`/blog-posts/admin/${id}`);
}

export async function createBlogPost(payload) {
  return request('/blog-posts', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateBlogPost(id, payload) {
  return request(`/blog-posts/admin/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteBlogPost(id) {
  return request(`/blog-posts/admin/${id}`, {
    method: 'DELETE',
  });
}

export async function toggleBlogPostPublish(id) {
  return request(`/blog-posts/admin/${id}/publish`, {
    method: 'POST',
  });
}

export async function getGallery(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/gallery${query ? `?${query}` : ''}`);
}

export async function getGalleryItem(id) {
  return request(`/gallery/${id}`);
}

export async function createGalleryItem(payload) {
  return request('/gallery', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateGalleryItem(id, payload) {
  return request(`/gallery/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteGalleryItem(id) {
  return request(`/gallery/${id}`, {
    method: 'DELETE',
  });
}

export async function createColor(payload) {
  return request('/colors', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateColor(id, payload) {
  return request(`/colors/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteColor(id) {
  return request(`/colors/${id}`, {
    method: 'DELETE',
  });
}

export async function uploadFile(file, options = {}) {
  const formData = new FormData();
  formData.append('file', file);

  if (options.folder) {
    formData.append('folder', options.folder);
  }

  const response = await fetch(`${API_BASE_URL}/upload`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload?.message || 'Dosya yüklenemedi');
  }

  return payload;
}
